import React from 'react';
import customStyles from "../../../../../../assets/styles/customStyles";
import { TextField } from "@mui/material";
import clsx from "clsx";
import { Col, Row } from "antd";

export const SendReceiptForm = (props) => {
    const { form, error, changeHandler } = props;
    const classes = customStyles();
    return (
        <Row type="flex" gutter={25} className={clsx(classes.removeUnderline)}>
            <Col span={24}><p>Please Enter the following details and Click OK to Send Receipt</p></Col>
            <Col span={24}>
                <TextField autoComplete='one-time-code'
                    label={["Name ", <span key={"name"} className={classes.colorRedRequired}> *</span>]}
                    fullWidth
                    type="text"
                    name="customerName"
                    className={clsx(classes.margin20t)}
                    error={error?.customerName ? true : false}
                    helperText={error?.customerName}
                    variant={'standard'}
                    value={form?.customerName || ''}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => changeHandler(e)}
                />
            </Col>
            <Col span={12}>
                <TextField autoComplete='one-time-code'
                    label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                    fullWidth
                    type="text"
                    name="customerMobile"
                    className={clsx(classes.margin20t)}
                    error={error?.customerMobile ? true : false}
                    helperText={error?.customerMobile}
                    variant={'standard'}
                    value={form?.customerMobile || ''}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => changeHandler(e)}
                />
            </Col><Col span={12}>
                <TextField autoComplete='one-time-code'
                    label={["Email ", <span key={"Email"} className={classes.colorRedRequired}> *</span>]}
                    fullWidth
                    type="email"
                    name="customerEmail"
                    className={clsx(classes.margin20t)}
                    error={error?.customerEmail ? true : false}
                    helperText={error?.customerEmail}
                    variant={'standard'}
                    value={form?.customerEmail || ''}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => changeHandler(e)}
                />
            </Col>
        </Row>
    )
}